import { i18nInstance } from '@/plugins/i18n';

export default function localize({ next }) {
	const currentLanguage = sessionStorage.getItem('currentLanguage');

	if (!currentLanguage || navigator.language !== currentLanguage) {
		i18nInstance.locale = navigator.language;
		sessionStorage.setItem('currentLanguage', navigator.language);
	}

	return next();
}
